import { HorarioRango } from '@/components/HolidayTimeRanges';

export interface Holiday {
  id: number;
  fecha: Date | string;
  festividad: string;
  tiemposDisponibles: HorarioRango[] | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface HolidayInput {
  fecha: string;
  festividad: string;
  tiemposDisponibles: HorarioRango[] | null;
  isActive: boolean;
}

export async function getHolidays(): Promise<Holiday[]> {
  const response = await fetch('/api/holidays', {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Error al cargar días festivos');
  }

  return response.json();
}

export async function createHoliday(data: HolidayInput): Promise<Holiday> {
  const response = await fetch('/api/holidays', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }

  return response.json();
}

export async function updateHoliday(id: number, data: HolidayInput): Promise<Holiday> {
  const response = await fetch(`/api/holidays/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }

  return response.json();
}

export async function deleteHoliday(id: number): Promise<void> {
  const response = await fetch(`/api/holidays/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });

  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }
}
